import React from 'react';
import { useDroppable } from '@dnd-kit/core';
import { observer } from 'mobx-react-lite';
import { Cross1Icon } from '@radix-ui/react-icons';
import { IconButton } from '@producer/ui-kit';

import { Shot } from '../../../app/entities';
import { SelectionProvider } from '../../../core/contexts/selection.context';
import { UnusedShotCard } from './unused-shot-card';
import { EmptyDrawerPlaceholder } from '../../../components/empty-drawer.placeholder';
import { ShotsIcon } from '../../../components/icons/shots.icon';
import { ToolBar, Tools } from '../../../components/toolbar/toolbar';

import styles from './shot-archive.drawer.module.scss';
interface ShotArchiveDrawerProps {
  onClose: () => void;
  shots: Shot[];
}

export const ShotArchiveDrawer: React.FC<ShotArchiveDrawerProps> = observer(
  ({ shots, onClose }) => {
    const unusedShotsIds = shots.map((shot) => shot._id);

    const { setNodeRef, isOver } = useDroppable({
      id: 'boneyard',
      data: { type: 'boneyard' },
    });

    return (
      <SelectionProvider items={unusedShotsIds}>
        <div className={styles['drawer']}>
          <ToolBar title="Shot archive">
            <Tools>
              <IconButton icon={<Cross1Icon />} onClick={onClose} />
            </Tools>
          </ToolBar>

          <div className={styles['content']} ref={setNodeRef}>
            {shots.length ? (
              <>
                {shots.map((shot) => (
                  <UnusedShotCard key={shot._id} shot={shot} />
                ))}

                {isOver && (
                  <div className={styles['placeholder']} data-is-over={isOver} data-is-overlay>
                    <EmptyDrawerPlaceholder
                      icon={<ShotsIcon />}
                      text={'Drop a shot here to remove it from the storyboard.'}
                    />
                  </div>
                )}
              </>
            ) : (
              <div className={styles['placeholder']} data-is-over={isOver}>
                <EmptyDrawerPlaceholder
                  icon={<ShotsIcon />}
                  text={
                    <div className={styles['empty-drawer-text-wrapper']}>
                      <p>
                        Drag a shot from the left into the shot archive to remove it from the
                        storyboard.
                      </p>
                      <p>The archive saves it for later use.</p>
                    </div>
                  }
                />
              </div>
            )}
          </div>
        </div>
      </SelectionProvider>
    );
  },
);
